/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	// JSON取得用 =========================================================
	let tagList = [];
	let newsList = [];

	const newsJpJson = () => `/ajax/jp/news/list.json`;
	const newsEnJson = () => `/ajax/en/news/list.json`;
	const newsCnJson = () => `/ajax/cn/news/list.json`;
	const newsTwJson = () => `/ajax/tw/news/list.json`;
	const getNewsJson = () => {
		if (isEnglishPage()) {
			return newsEnJson();
		} else if (isSimplifiedChinesePage()) {
			return newsCnJson(); // 中国語（簡体）
		} else if (isTraditionalChinesePage()) {
			return newsTwJson(); // 中国語（繁体）
		} else {
			return newsJpJson(); // 日本語（デフォルト）
		}
	}

	const newsProNextJpJson = () => `https://ssl4.eir-parts.net/V4Public/eir/8283/ja/announcement/announcement_16.js`;
	const newsProNextEnJson = () => `https://ssl4.eir-parts.net/V4Public/eir/8283/en/announcement/announcement_17.js`;

	const tagsKey = 'rt_bn_tags';
	const newsKey = 'rt_bn_news';
	const newsListSelector = '.js-news-list-content';

	let $path = window.location.pathname;

	const isEnglishPage = () => $path.startsWith('/en');
	const isSimplifiedChinesePage = () => $path.startsWith('/cn');
	const isTraditionalChinesePage = () => $path.startsWith('/tw');

	const categoryAll = () => getCategoryAll();
	const getCategoryAll = () => {
		if (isEnglishPage()) {
			return 'All';
		} else if (isSimplifiedChinesePage()) {
			return '新闻';
		} else if (isTraditionalChinesePage()) {
			return '新聞';
		} else {
			return 'すべて';
		}
	}

	const categoryNotice = () => getCategoryNotice();
	const getCategoryNotice = () => {
		if (isEnglishPage()) {
			return 'Notice';
		} else if (isSimplifiedChinesePage()) {
			return '新闻';
		} else if (isTraditionalChinesePage()) {
			return '新聞';
		} else {
			return 'お知らせ';
		}
	}

	const categoryIr = () => getCategoryIr();
	const getCategoryIr = () => {
		if (isEnglishPage()) {
			return 'IR Information';
		} else if (isSimplifiedChinesePage()) {
			return '新闻';
		} else if (isTraditionalChinesePage()) {
			return '新聞';
		} else {
			return 'IR情報';
		}
	}


	const tagIrKessan = () => isEnglishPage() ? 'Financial Results' : '決算';
	const tagIrKessanKey = 'ir-kessan';
	const tagIrTekiji = () => isEnglishPage() ? 'Timely Disclosure' : '適時開示';
	const tagIrTekijiKey = 'ir-soukai';
	const tagIrNews = () => isEnglishPage() ? 'News Releases' : 'ニュースリリース';
	const tagIrNewsKey = 'ir-news';
	const tagIrSonota = () => isEnglishPage() ? 'Other IR Information' : 'その他IR資料';
	const tagIrSonotaKey = 'ir-sonota';
	const tagNotice = () => isEnglishPage() ? 'Notice' : 'お知らせ';
	const tagNoticeKey = 'notice';

	// ====================================================================
	// <ニュース一覧>JSON取得
	const getJson = async (lang, tagsKey, newsKey, categoryFilters = ['notice', 'ir']) => {
		const { tagList, newsList } = await Promise.all([
			(() => { return {} })(),
			fetch(getNewsJson()).then(res => res.json()),
			fetch(isEnglishPage() ? newsProNextEnJson() : newsProNextJpJson()).then(res => res.text()).then(res => {
				let json = res.slice(25);
				json = json.slice(0, json.length - 2);
				return JSON.parse(json);
			}),
		]).then(([tagList, newsList, proNextNewsList]) => {
			const parsedTags = (tagList[tagsKey] || []).map((tag) => {
				return {
					category: '',
					key: tag._key || '',
					label: tag.cf_nt_name_d || tag.cf_nt_name_d_en || '',
				}
			});

			const parsedNews = (newsList[newsKey] || []).map((news) => {
				return {
					category: 'notice',
					isPdf: news.rt_cf_n_attachment_file_icon_pdf !== null || news.rt_cf_n_url_icon_pdf !== null,
					isNew: news.rt_cf_n_icon_new !== null,
					fileSize: bytesToSize(news.rt_cf_n_attachment_file_size?.content || news.rt_cf_n_url_file_size?.content || 0),
					title: (news.rt_cf_n_title?.content || []).join(''),
					link: news.rt_cf_n_href?.href || '',
					target: news.rt_cf_n_href?.target || '_self',
					linkStyle: news.rt_cf_n_href?.style || '',
					linkClassList: (news.rt_cf_n_href?.class || '').split(' '),
					date: news.rt_cf_n_date?.content || '',
					year: (news.rt_cf_n_date?.datetime || '').slice(0, 4),
					tags: [{
						key: 'notice',
						label: categoryNotice()
					}],
					dt: new Date(news.rt_cf_n_date?.datetime || '0000-12-31'),
				}
			});

			const parsedProNextNews = (proNextNewsList['item'] || [])
				.map((news) => {
					if (isSimplifiedChinesePage() || isTraditionalChinesePage()) return {};
					// console.log(news)
					// only number from string
					const fileSize = news.file_size?.replace(/\D/g, '');
					const newsDate = new Date(news.date || '0000-12-31');

					// newsDateから30日以内の場合はnew
					const newFlgDate = new Date(news.date || '0000-12-31');
					newFlgDate.setDate(newFlgDate.getDate() + 30);

					let tag = { key: '', label: '' };

					if (isEnglishPage()) {
						if (
							news.sub_type === 'id240'
						) {
							tag.key = tagIrTekijiKey;
							tag.label = tagIrTekiji();
						} else if (
							[
								'announcement4',
								'ir_material9'
							].includes(news.sub_type)
						) {
							tag.key = tagIrSonotaKey;
							tag.label = tagIrSonota();
						} else {
							tag.key = "";
							tag.label = "";
						}
					} else {
						if (
							news.news_type === 'tanshin'
						) {
							tag.key = tagIrKessanKey;
							tag.label = tagIrKessan();
						} else if (
							news.news_type === 'press'
						) {
							if (news?.title?.includes("決算説明資料")) {
								tag.key = tagIrKessanKey;
								tag.label = tagIrKessan();
							} else {
								tag.key = tagIrTekijiKey;
								tag.label = tagIrTekiji();
							}
						} else if (
							news.news_type === 'yuho'
							||
							[
								'announcement2',
								'ir_material10',
								'ir_material5',
								'ir_material7',
								'ir_material8'
							].includes(news.sub_type)
						) {
							tag.key = tagIrSonotaKey;
							tag.label = tagIrSonota();
						} else if (
							news.news_type === 'pr'
						) {
							if (news?.title?.includes("決算説明資料")) {
								tag.key = tagIrKessanKey;
								tag.label = tagIrKessan();
							} else {
								tag.key = tagIrNewsKey;
								tag.label = tagIrNews();
							}
						} else {
							tag.key = tagIrNewsKey;
							tag.label = tagIrNews();
						}
					}

					return {
						category: 'ir',
						isPdf: news.type === 'pdf',

						isNew: new Date() < newFlgDate,

						fileSize: bytesToSize((fileSize || 0) * 1000),
						title: news.title || '',
						link: news.link,
						target: '_blank',
						linkStyle: '',
						linkClassList: [],
						date: news.format_date || '',

						year: (news.date || '').slice(0, 4),
						tags: tag.key ? [tag] : [],
						news_type: news.news_type,
						dt: newsDate,
					}
				});

			const set = new Set();
			parsedProNextNews.forEach((news) => {
				set.add(news.news_type);
			});

			const combinedNewsList = parsedNews.concat(parsedProNextNews);
			combinedNewsList.sort((a, b) => {
				return b.dt - a.dt;
			});

			const combinedTagList = isEnglishPage() ? [
				{ category: 'notice', key: tagNoticeKey, label: tagNotice() },
				{ category: 'ir', key: tagIrTekijiKey, label: tagIrTekiji() },
				{ category: 'ir', key: tagIrSonotaKey, label: tagIrSonota() },
				...parsedTags,
			] : [
				{ category: 'notice', key: tagNoticeKey, label: tagNotice() },
				{ category: 'ir', key: tagIrNewsKey, label: tagIrNews() },
				{ category: 'ir', key: tagIrKessanKey, label: tagIrKessan() },
				{ category: 'ir', key: tagIrTekijiKey, label: tagIrTekiji() },
				{ category: 'ir', key: tagIrSonotaKey, label: tagIrSonota() },
				...parsedTags,
			];

			return Promise.resolve({
				tagList: combinedTagList,
				newsList: combinedNewsList,
			});
		}).then(({ tagList, newsList }) => {
			// filter with tagList and newsList using categoryFilters
			const filteredTagList = tagList.filter((tag) => {
				if (tag.key === '') {
					return true;
				}
				return categoryFilters.includes(tag.category);
			});

			const filteredNewsList = newsList.filter((news) => {

				return categoryFilters.includes(news.category);
			});

			return {
				tagList: filteredTagList,
				newsList: filteredNewsList,
			};
		});
		return { tagList, newsList };
	}

	const getFilteredTagList = (tagList) => {
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';

		const filteredTagList = tagList
			.filter((tag) => {
				if (tag.key === '') {
					return true;
				}
				// categories
				return pCategory ? tag.category === pCategory : true;
			});

		return filteredTagList;

	}

	const getFilteredNewsList = (newsList) => {
		const limit = getLimit();
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';
		const pTag = searchParams.get('p_tag') || '';

		const filteredNewsList = newsList
			.filter((news) => {
				// categories
				return pCategory ? news.category === pCategory : true;
			})
			.filter((news) => {
				// tags
				return news.tags.filter((tag) => {
					return pTag ? tag.key === pTag : true;
				}).length > 0 || (!pTag && news.tags.length === 0);
			})
			.filter((news) => {
				// year
				return searchParams.get('p_year') ? news.year === searchParams.get('p_year') : true;
			})
			.filter((news, idx) => {
				// limit
				return limit ? idx < limit : true;
			});

		return filteredNewsList;
	}

	// Lang ==============================================================
	const getLang = () => {
		return isEnglishPage()
			? 'en'
			: '';
	}

	// limit ==============================================================
	const getLimit = () => {
		let limit = null;
		if (['/', '/index.html', '/en/', '/en/index.html', '/cn/', '/cn/index.html', '/tw/', '/tw/index.html'].includes(window.location.pathname)) {
			limit = 5;
		} else if (['/ir/', '/ir/index.html', '/en/ir/', '/en/ir/index.html'].includes(window.location.pathname)) {
			limit = FUNCTIONS.va.isMobile ? 5 : 10;
		} else if (['/news/', '/news/index.html', '/en/news/', '/en/news/index.html', '/cn/news/', '/cn/news/index.html', '/tw/news/', '/tw/news/index.html'].includes(window.location.pathname)) {
			const pYear = new URLSearchParams(window.location.search).get('p_year') || '';
			if (pYear === '') {
				limit = 30;
			}
		}

		return limit;
	}

	// Generate Elements ==============================================================
	const bytesToSize = (bytes) => {
		const kilobytes = bytes / 1024;
		const nf = new Intl.NumberFormat('en-US');
		return nf.format(kilobytes.toFixed(0)) + 'KB';
	}

	const generateYearDropDown = (newsList) => {
		const yearElem = document.querySelector('.js-news-yearList');

		if (!yearElem) {
			return;
		}
		yearElem.innerHTML = '';

		const pYear = new URLSearchParams(window.location.search).get('p_year') || '';

		const yearSet = new Set(newsList.map((news) => news.year));
		const yearArr = Array.from(yearSet).sort((a, b) => b - a);
		const option = document.createElement('option');
		option.textContent = isEnglishPage() ? 'Latest' : '最新';
		option.value = "";

		if (pYear === '') {
			option.selected = true;
		}

		yearElem.appendChild(option);

		yearArr.map((year) => {
			const option = document.createElement('option');
			option.textContent = year;
			option.value = year;
			if (pYear == year) {
				option.selected = true;
			}
			yearElem.appendChild(option);
		});
	}

	const generateNewsElement = (news) => {
		// console.log(news)
		const newsElement = document.createElement('li');

		newsElement.innerHTML = `
			<p class="_date js-news-date">
				<!-- 年月日: .js-news-date -->
			</p>
			<div class="js-news-category">
			</div>
			<a href="" class="mod-link01 _title js-news-link" target="">
				<span class="js-news-link-title">
					<!-- タグ: .js-news-link-title -->
				</span>
				<svg aria-hidden="true" class="di_none">
					<use xlink:href="/common/svg/sprite.svg#pdf"></use>
				</svg>
				<svg aria-hidden="true" class="_blank di_none">
					<use xlink:href="/common/svg/sprite.svg#blank"></use>
				</svg>
				<span class="js-fileSize di_none"></span>
				<div class="mod-new-icon di_none">NEW</div>
			</a>
		`

		// 年月日
		newsElement.querySelector('.js-news-date').textContent = (isEnglishPage() && news.category === "ir") ? news.date + ", " + news.year : news.date;

		// タグ
		news.tags.forEach((tag) => {
			const tagElement = document.createElement('p');
			tagElement.classList.add('mod-tag');
			tagElement.textContent = tag.label;
			if (tag.label === "") {
				tagElement.classList.add('_borderNone');
			}
			newsElement.querySelector('.js-news-category').appendChild(tagElement);
		});

		// NEW アイコン
		if (news.isNew) {
			newsElement.querySelector('.mod-new-icon').classList.remove('di_none');
		}

		// ニュース詳細リンク
		newsElement.querySelector('.js-news-link').href = news.link;
		newsElement.querySelector('.js-news-link').target = news.target;
		newsElement.querySelector('.js-news-link').style = news.linkStyle;
		news.linkClassList.forEach((className) => {
			if (className) {
				newsElement.querySelector('.js-news-link').classList.add(className);
			}
		});

		// タイトル
		newsElement.querySelector('.js-news-link-title').textContent = news.title;

		// PDF アイコン
		if (news.isPdf) {
			newsElement.querySelector('.js-news-link svg').classList.remove('di_none');
		}

		// ファイルサイズ
		if (news.fileSize && news.fileSize !== "0KB") {
			newsElement.querySelector('.js-news-link .js-fileSize').textContent = '（' + news.fileSize + '）';
			newsElement.querySelector('.js-news-link .js-fileSize').classList.remove('di_none');
		}

		// ブランクアイコン
		if (!news.isPdf && (news.target === '_blank' || news.link.startsWith('http'))) {
			newsElement.querySelector('.js-news-link ._blank').classList.remove('di_none');
		}

		return newsElement;
	}

	const generateTagsElement = (tag) => {
		const tagElement = document.createElement('a');
		tagElement.classList.add('mod-tag');

		const url = new URL(window.location.href);
		const currentPtag = url.searchParams.get('p_tag') || '';
		url.searchParams.set('p_tag', tag.key);

		const href = url.pathname + url.search;

		tagElement.textContent = tag.label;
		tagElement.href = href;

		if (currentPtag === tag.key) {
			tagElement.classList.add('is-active');
		}

		return tagElement;
	}

	const appendNewsElements = (newsList) => {
		const newsListElement = document.querySelector(newsListSelector);
		if (!newsListElement) return;
		newsListElement.innerHTML = '';

		if (newsListElement) {
			if (newsList.length === 0) {
				const elem = document.createElement('div');
				// <div class="js-news-list-content">
				elem.classList.add('js-news-list-content');
				elem.textContent = isEnglishPage() ? 'There is no corresponding news.' : '該当するニュースはございません。';
				newsListElement.appendChild(elem);
			} else {
				newsList.forEach((news) => {
					const elem = generateNewsElement(news);
					newsListElement.appendChild(elem);
				});
			}
		}
	}

	const appendTagsElements = (tagList) => {
		const tagsElement = document.querySelector('.js-news-wrap .js-news-category-tag');
		if (tagsElement) {
			tagsElement.innerHTML = '';
			tagList.forEach((tag) => {
				tagsElement.appendChild(generateTagsElement(tag));
			});
		}
	}

	const setCurrentCategory = () => {
		const searchParams = new URLSearchParams(window.location.search);
		const pCategory = searchParams.get('p_category') || '';

		document.querySelectorAll('.mod-news-tab-item').forEach((node) => {
			if (node.textContent === categoryNotice() && pCategory === 'notice') {
				node.classList.add('is-active');
			} else if (node.textContent === categoryIr() && pCategory === 'ir') {
				node.classList.add('is-active');
			} else if (node.textContent === categoryAll() && !pCategory) {
				node.classList.add('is-active');
			} else {
				node.classList.remove('is-active');
			}
		});

	}


	// init ==============================================================
	const addEventListener = () => {
		const tagsElements = document.querySelectorAll('.js-news-category-tag');

		if (tagsElements) {
			const tagEvent = (e) => {
				if (e.target.classList.contains('mod-tag')) {
					e.preventDefault();
					const url = new URL(window.location.href);
					const targetUrl = new URL(e.target.href);
					url.searchParams.set('p_tag', targetUrl.searchParams.get('p_tag') || '');

					// push state
					window.history.replaceState({}, '', url.search);

					initHtml();
				}
			};

			tagsElements.forEach((node) => {
				node.removeEventListener('click', tagEvent);
				node.addEventListener('click', tagEvent);
			});
		}

		const tabElements = document.querySelectorAll('.mod-news-tab-item');
		if (tabElements) {
			const tabEvent = (e) => {
				e.preventDefault();

				const text = e.target.textContent;

				const category = text === categoryNotice() ? 'notice' : text === categoryIr() ? 'ir' : '';

				const url = new URL(window.location.href);
				url.searchParams.set('p_category', category);
				url.searchParams.delete('p_tag');

				// push state
				window.history.pushState({}, '', url.search);
				initHtml();
			};
			tabElements.forEach((node) => {
				node.removeEventListener('click', tabEvent);
				node.addEventListener('click', tabEvent);
			});
		}

		const yearListElement = document.querySelector('.js-news-yearList');
		if (yearListElement) {
			const yearListEvent = (e) => {
				const url = new URL(window.location.href);
				url.searchParams.set('p_year', e.target.value);

				// push state
				window.history.pushState({}, '', url.search);
				initHtml();
			};

			yearListElement.removeEventListener('change', yearListEvent);
			yearListElement.addEventListener('change', yearListEvent);
		}
	}

	const initHtml = () => {
		// カテゴリー
		setCurrentCategory();

		// タグ
		appendTagsElements(getFilteredTagList(tagList));

		// ニュース
		const filteredNewsList = getFilteredNewsList(newsList);
		generateYearDropDown(newsList);
		appendNewsElements(filteredNewsList);

	}

	const init = async () => {
		const lang = getLang();

		let categoryFilters = ['notice', 'ir'];
		if ([
			'/ir/',
			'/ir/index.html',
			'/en/ir/',
			'/en/ir/index.html',
		].includes(window.location.pathname)) {
			categoryFilters = ['ir'];
		}

		const jsonData = await getJson(lang, tagsKey, newsKey, categoryFilters);

		tagList = jsonData.tagList || [];
		newsList = jsonData.newsList || [];

		initHtml();
		addEventListener();

	}


	init();
})(window.FUNCTIONS);
